module.exports = __webpack_public_path__ + "static/media/IMG-9565.65e231cb.jpg";